import { get, set } from "idb-keyval";
import type { Deck, ExamId, SessionLog, Settings, WordProgress } from "./types";

export interface AppState {
  settings: Settings;
  decks: Deck[];
  progress: Record<string, WordProgress>; // key = wordId
  logs: SessionLog[];
  onboarded: boolean;
  targetExam: ExamId;
  targetDeadline?: string;
  startingBand?: number;
}

const STATE_KEY = "mangoword-app-state";
const LEGACY_STATE_KEY = "cibook-app-state";

export const defaultSettings = (): Settings => ({
  learnerName: "Kelvin",
  dailyGoal: 20,
  feedbackStyle: "instant",
  showPhonetics: true,
  pronunciation: "uk",
  defLang: "zh+en",
  autoReadExample: false,
  reminderTimes: ["07:30"],
});

export const defaultState = (): AppState => ({
  settings: defaultSettings(),
  decks: [],
  progress: {},
  logs: [],
  onboarded: false,
  targetExam: "hkdse",
});

export async function loadState(): Promise<AppState> {
  const stored = (await get<AppState>(STATE_KEY)) ?? (await get<AppState>(LEGACY_STATE_KEY));
  if (!stored) return defaultState();
  // 与默认结构合并,容忍旧版本缺字段
  return { ...defaultState(), ...stored, settings: { ...defaultSettings(), ...stored.settings } };
}

export async function saveState(s: AppState): Promise<void> {
  await set(STATE_KEY, s);
}
